import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import anime from "animejs"
import styled from "styled-components"
import { IconLoader } from "@components/icons"

const StyledLoader = styled.div`
  ${({ theme }) => theme.mixins.flexCenter};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) =>
    theme.mode === "light" ? "#ffffff" : "#000000"};
  z-index: 99;

  .logo-wrapper {
    width: max-content;
    max-width: 50px;
    transition: opacity 0.3s ease-in-out;
    opacity: ${props => (props.isMounted ? 1 : 0)};
    svg {
      display: block;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      fill: none;
      user-select: none;
      path {
        stroke: #0071e3;
        stroke-width: 2;
        opacity: 1;
      }
    }
  }
`

const Loader = ({ finishLoading }) => {
  const [isMounted, setIsMounted] = useState(false)

  const animate = () => {
    anime.timeline({
      complete: () => finishLoading(),
    })
  }

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 10)
    animate()
    return () => clearTimeout(timeout)
  }, [])

  return (
    <StyledLoader className="loader" isMounted={isMounted}>
      <Helmet bodyAttributes={{ class: `hidden` }} />
      <div className="logo-wrapper">
        <IconLoader />
      </div>
    </StyledLoader>
  )
}

Loader.propTypes = {
  finishLoading: PropTypes.func.isRequired,
}

export default Loader
